<template>
  <div class="tab-filled" :class="variant">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'tab-filled',
  components: {
  },
  props: {
    'active': '',
    'show': '',
    'variant': ''
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
</style>



// WEBPACK FOOTER //
// src/components/tabs/TabFilled.vue